import { RSAA } from 'redux-api-middleware';

// Constants
export const CONTROL_IS_FETCHING = 'CONTROL_IS_FETCHING';
export const CONTROL_GET_ROOT_SUCCESS = 'CONTROL_GET_ROOT_SUCCESS';
export const CONTROL_GET_ROOT_ERROR = 'CONTROL_GET_ROOT_ERROR';

// Actions
export const getRootControls = () => {
  return {
    [RSAA]: {
      endpoint: '/api/v1',
      method: 'GET',
      types: [CONTROL_IS_FETCHING, CONTROL_GET_ROOT_SUCCESS, CONTROL_GET_ROOT_ERROR]
    }
  };
};

// Initial State
export const initialState = {
  items: {},
  error: null
};

// Reducer
export default (state = initialState, action) => {
  switch (action.type) {
    case CONTROL_GET_ROOT_SUCCESS:
      return {
        ...state,
        items: Object.keys(action.payload).reduce((res, e) => {
          if (!res[e]) {
            res[e] = action.payload[e];
          }
          return res;
        }, {})
      };

    case CONTROL_GET_ROOT_ERROR:
      return {
        ...state,
        error: action.payload
      };
    default:
      return state;
  }
};
